import { render, staticRenderFns } from "./study-milestones.vue?vue&type=template&id=ec0e0878&scoped=true&"
import script from "./study-milestones.vue?vue&type=script&lang=js&"
export * from "./study-milestones.vue?vue&type=script&lang=js&"
import style0 from "./study-milestones.vue?vue&type=style&index=0&id=ec0e0878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0e0878",
  null
  
)

component.options.__file = "study-milestones.vue"
export default component.exports